/* Trade form submission to Salesforce */
/*
Forms integrated:
/account
*/
$(document).ready(function(){
	/* Submit to salesforvce */
	function submitToSalesforce1(){
		var firstName = $("input#firstnameField").val(); //ok
		var lastname = $("input#lastnameField").val(); //ok
		var sf_email = $("input#emailField").val(); //ok
		var sf_phone = $("input#phoneField").val(); //ok
		var sf_country = $("select.country").val(); //ok
      	var sf_city = $("input#cityField").val(); //ok
		var sf_state = $("input#stateField").val(); //ok
		var sf_zip = $("input#zipField").val(); //ok
		var sf_company = $("input#companyField").val(); //ok
		var sf_landingPage = $("input.landing-page-url").val(); //ok
		var sf_keyword = $("input.keyword").val(); //ok
		var sf_gclid = $("input.gclid").val(); //ok
		var sf_bindId = $("input.bind-id").val(); //ok
		var sf_productType = $("input.product-type").val(); //ok
		var sf_leadSource = $("input.lead-source").val(); //ok
		var sf_campaignId = $("input.campaign-id").val(); //ok
		var sf_dclid = $("input.dclid").val(); //ok
		var sf_referrerDomain = $("input.referrer-domain").val(); //ok
		var sf_campaignContent = $("input.campaign-content").val(); //ok
		var sf_leadMedium = $("input.lead-medium").val(); //ok
		var sf_trade_pricing = "Yes";
		var sf_tax_id = $('input#TaxIdField').val(); //ok
        var sf_comments = $(".contact-body").val();
        var novobi_form_id = $('input.novobi-form-id').val();
      
      
      	// Mailchimp Campaign Name
      	if (getCookie("ct") != "")
        {
        	sf_leadSource 		= getCookie("ct");
        }
      
        // Mailchimp ID for the campaign that generated the link
      	if (getCookie("mc_cid") != "")
        {        	
          	sf_campaignContent 	= getCookie("mc_cid");
        }
      
      	// unique Mailchimp ID that identifies the recipient’s email address
      	if (getCookie("mc_eid") != "")
        {
        	sf_leadMedium 		= getCookie("mc_eid");	
        }
      
      
      	// Google Campaign info
      	if (getCookie("utm_source") != "")
        {
        	sf_leadSource 		= getCookie("utm_source");
        }
      
      	if (getCookie("utm_campaign") != "")
        {        	
          	sf_campaignContent 	= getCookie("utm_campaign");
        }
      
      	if (getCookie("utm_medium") != "")
        {
        	sf_leadMedium 		= getCookie("utm_medium");	
        }
      	
      
		
		var formData = { 
            novobi_form_id: novobi_form_id,
			oid: "00D700000008Q49",
			retURL: "https://kb2018.myshopify.com/pages/test-thank-you-page",
			"00N0g000003MsOv": 1,
			"00N0g000003Mrqy": sf_landingPage,
			"00N0g000003Mrr3": sf_keyword,
			"00N0g000003Mrr8": sf_gclid,
			"00N0g000003MrrD": sf_bindId,
			"00N0g000003MrrI": sf_productType,
			"00N70000001lU8u": sf_campaignId,
			"00N0g000003MsFP": sf_dclid,
			"00N0g000003MsFU": sf_referrerDomain,
			"00N0g000003MsFZ": sf_campaignContent,
			"00N0g000003MsFe": sf_leadMedium,
			"00N0g000003MrrN": sf_tax_id,
			"00N0g000003hvkX": sf_trade_pricing,
			"00N0g000003MsHG": "Website designer application",
			lead_source: sf_leadSource,
			first_name: firstName, 
			last_name: lastname,
			email: sf_email, 
			phone: sf_phone,
          	city: sf_city, 
			state: sf_state,
			zip: sf_zip,
			country: sf_country,
			company: sf_company,
            "00N0g000003V6bT" : sf_comments,
		}
		console.log('Submitting to Salesforce - Account');
      	// console.log(formData);
		$.ajax({
		  type: "POST",
		  // url: 'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8',
          url: 'https://kyle-bunting.odoo.com/shopify-form/submit',
		  data: formData,
		  success: afterSubmission,
		  error: afterSubmission,
		  dataType: 'json',
		  crossDomain : true,
		});	
	}

	/* Prevent submission */
	$(".salesforce-integration-3 .submit-trigger").click(function(e){
		e.preventDefault();
		console.log('test /account');
		isFormValid = validateForm();
      	console.log(isFormValid);
		if(isFormValid){
			showErrors(false);
			submitToSalesforce1();
		}else{
			showErrors(true);
		}
	});

	/* **************** */
	/* Helper functions */
	/* **************** */
	function validateForm(){
		isValid = false;
      	fnField = $("input#firstnameField").val(); //ok
		lnField = $("input#lastnameField").val(); //ok
		phField = $("input#phoneField").val(); //ok
      	companyField = $("input#companyField").val();
      	countryField = $("select.country").val();
		emailField = $("input#emailField").val();
      	stateField = $("input#stateField").val();
		emailValidation = validateEmail(emailField);
		if(emailValidation && countryField != null && fnField && lnField && phField && companyField && stateField){
			isValid = true;
		}
		return isValid;
	}

	function validateEmail(email){
		result = false;
		rule = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
		if (rule.test(email)){
			return true;
		}
		return result;
	}

	function showErrors(show){
		if(show){
			$("div#formErrors").html('Please fill out the required fields.');
		}else{
			$("div#formErrors").html('');
		}	
	}

	function afterSubmission(data){
		console.log("Submitting to Shopify");
		$(".salesforce-integration-3 form").submit();
	}
});	